import { useLocation, useNavigate } from 'react-router-dom'
import { ShieldCheck } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { openVerifyIdentity } from '@/lib/verify-identity-navigation'

/**
 * Inline soft KYC gate — server still requires `isIdentityVerified`.
 * Opens the Sumsub verify modal over the current screen.
 */
export function SoftIdentityGate({
  title = 'Identity verification required',
  description = 'Creating Biddles, buying letter credits, and claiming properties requires identity verification. It usually takes less than two minutes.',
  onCancel,
}: {
  title?: string
  description?: string
  /** When set, Cancel runs this instead of navigating to search. */
  onCancel?: () => void
}) {
  const navigate = useNavigate()
  const location = useLocation()
  const next = `${location.pathname}${location.search}`

  return (
    <div className="w-full">
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <ShieldCheck className="h-5 w-5 text-biddle-blue" />
            {title}
          </CardTitle>
          <CardDescription>{description}</CardDescription>
        </CardHeader>
        <CardContent className="flex flex-wrap items-center justify-between gap-2">
          {onCancel ? (
            <Button type="button" variant="ghost" onClick={onCancel}>
              Cancel
            </Button>
          ) : (
            <Button type="button" variant="ghost" onClick={() => navigate('/search')}>
              Cancel
            </Button>
          )}
          <Button
            type="button"
            variant="primary"
            onClick={() => openVerifyIdentity(navigate, location, next)}
          >
            Verify identity
          </Button>
        </CardContent>
      </Card>
    </div>
  )
}
